import axios from '@/axios/api.request'

export const save = (from) => axios.request({
    url: 'notice/info/save',
    data: from,
    method: 'post'
})

export const notices = (from) => axios.request({
    url: 'notice/info/byUid',
    data: from,
    method: 'post'
})

export const read = (from) => axios.request({
    url: 'notice/info/read',
    data: from,
    method: 'post'
})